import { createContext, useContext, useEffect, useState } from 'react'
import api from '../../api/client'
import { useAuth } from '../../context/AuthContext'

// Acceso en la versión móvil (/m) = el mismo menú por rol y por persona de la
// compu (Martin, 22 oct 2026: un usuario de logística entraba por el celular y
// veía todo). Cada pantalla móvil se habilita con los ítems de escritorio que
// la contienen: alcanza con ver cualquiera de ellos. La home, la barra de
// pestañas y la ruta misma leen esta tabla — una pantalla nueva de /m se suma
// acá; si no está, no se ve.
const SOLO_SUPER = 'solo_super'
const REGLAS = [
  [/^\/m\/clientes\/[^/]+\/historia/, ['/clientes/historia']],
  [/^\/m\/historia/, ['/clientes/historia']],
  [/^\/m\/clientes/, ['/clientes/historia', '/clientes/deudores']],
  [/^\/m\/deudores/, ['/clientes/deudores']],
  [/^\/m\/ventas/, ['/notas-venta']],
  // El cobro se abre desde el detalle de la venta: quien ve la NV ve lo que hay adentro.
  [/^\/m\/pagos/, ['/finanzas/pagos', '/notas-venta']],
  [/^\/m\/logistica/, ['/logistica/remitos']],
  [/^\/m\/reparto/, ['/logistica/distribucion']],
  [/^\/m\/tablero/, ['/informes']],
  [/^\/m\/resenas/, ['/clientes/resenas']],
  [/^\/m\/wine-club/, ['/clientes/wine-club']],
  [/^\/m\/experiencias/, ['/web/experiencias']],
  [/^\/m\/whatsapp/, ['/comunicaciones/whatsapp']],
  [/^\/m\/fotos/, ['/stock/fotos-pendientes']],
  [/^\/m\/conteo/, ['/stock/inventario']],
  [/^\/m\/consultas-stock/, ['/stock/consultas-deposito']],
  [/^\/m\/reportes/, ['/bi/reportes']],
  [/^\/m\/precios-ml/, SOLO_SUPER], // Martin, 29 sep 2026: "solo yo"
]

const AccesoMovilContext = createContext({ cargado: false, puede: () => false })

export function AccesoMovilProvider({ children }) {
  const { isSuperAdmin } = useAuth()
  const [menu, setMenu] = useState(null)

  useEffect(() => {
    api.get('/menu-permisos/mias')
      .then(({ data }) => setMenu(data))
      .catch(() => setMenu({ todo: false, items: [], restringidos: [], mios: [] }))
  }, [])

  const veItem = (item) => ((menu.restringidos || []).includes(item)
    ? (menu.mios || []).includes(item)
    : (!!menu.todo || (menu.items || []).includes(item)))

  const puede = (pathname) => {
    if (!menu) return false
    const p = (pathname || '').replace(/\/$/, '') || '/m'
    if (p === '/m') return true
    const regla = REGLAS.find(([re]) => re.test(p))
    if (!regla) return false
    if (regla[1] === SOLO_SUPER) return !!isSuperAdmin
    return regla[1].some(veItem)
  }

  return (
    <AccesoMovilContext.Provider value={{ cargado: !!menu, puede }}>
      {children}
    </AccesoMovilContext.Provider>
  )
}

export const useAccesoMovil = () => useContext(AccesoMovilContext)
